import { ButtonType } from "@components/Button/types";
import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { useDeleteInviteToShareGoal, useErrorBanner, useModal } from "@hooks";
import { i18n, Translations } from "@i18n";
import { CancelInviteModalProps } from "./types";

export const CancelInviteModal = ({ phoneNumber, id, goalId }: CancelInviteModalProps) => {
  const { dismiss } = useModal();
  const { showErrorBanner } = useErrorBanner();

  const [deleteInvite, { loading }] = useDeleteInviteToShareGoal({ goalId });

  const handleConfirm = async () => {
    try {
      await deleteInvite({
        variables: {
          shareGoalInviteId: id,
        },
      });
    } catch {
      showErrorBanner();
    } finally {
      dismiss();
    }
  };

  const props: OverlayProps = {
    title: i18n.t(Translations.CancelInviteModalTitle),
    subtitle: i18n.t(Translations.CancelInviteModalSubtitle, { phoneNumber }),
    cta: {
      primary: {
        title: i18n.t(Translations.CancelInviteModalPrimaryCTA),
        onClick: handleConfirm,
        type: ButtonType.Danger,
        loading,
      },
      secondary: {
        title: i18n.t(Translations.CancelInviteModalSecondaryCTA),
        onClick: dismiss,
      },
    },
    horizontal: true,
  };

  return <Overlay {...props} />;
};
